import { Button } from '@mui/material';

import { RetailerNetworkLocationOfferMetricsOverviewFragment } from '@occc/graphql';
import { PageSection } from '@occc/ui-design-system';
import { IPaginationProps } from '@occc-app/design-system';
import { SortingDirection } from '@occc-app/hooks/useSortingParams';

import { OfferPerformanceTable } from './offer-performance-table';

type OfferPerformanceProps = {
  data?: RetailerNetworkLocationOfferMetricsOverviewFragment[];
  isLoading: boolean;
  isRetailerNetworkSiteUserRole: boolean;
  hasError: boolean;
  paginationProps: IPaginationProps;
  sortDirection?: SortingDirection;
  onViewPerformance: () => void;
  onSort: () => void;
};

export const OfferPerformance = ({
  data,
  isLoading,
  isRetailerNetworkSiteUserRole,
  hasError,
  paginationProps,
  sortDirection = 'desc',
  onSort,
  onViewPerformance,
}: OfferPerformanceProps) => (
  <PageSection
    title='Offer Performance'
    description='Monitor redemptions'
    actions={
      !isRetailerNetworkSiteUserRole ? (
        <Button color='primary' variant='contained' onClick={onViewPerformance}>
          View Performance
        </Button>
      ) : null
    }
    hasError={hasError}
    isLoading={isLoading}
  >
    <OfferPerformanceTable
      data={data}
      paginationProps={paginationProps}
      sortDirection={sortDirection}
      isRetailerNetworkSiteUserRole={isRetailerNetworkSiteUserRole}
      onSort={onSort}
    />
  </PageSection>
);
